import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { GceManagementService } from '../../services/gce-management.service';
import { ExcelService } from '../../services/excel.service';
import { ClinichedatabaseService } from '../../services/clinichedatabase.service';
import { AuthGuardService } from '../../services';
import * as XLSX from 'xlsx';
import { take } from 'rxjs/operators';
const dateFormatDate = "YYYY-MM-DD";


interface Clinica {
  code_c: string;
  descrizione: string;
}

@Component({
  selector: 'app-gce-contract',
  templateUrl: './gce-contract.component.html',
  styleUrls: ['./gce-contract.component.css']
})

export class GceContractComponent implements OnInit {

  data: any[] = [];
  dataToDelete: any[] = [];
  headers: string[] = [];
  selectedRow: number | null = null;
  selectedCell: { row: number; col: number } | null = null;
  fileName: string = 'PLANNINGHRM';
  sheetName: string = 'MASTER';
  showb: boolean = false;

  clinicheList: Clinica[] = [];
  isLoadingCliniche: boolean = false;

  // Proprietà per paginazione
  currentPage: number = 1;
  pageSize: number = 20;
  totalPages: number = 1;
  displayedData: any[] = [];
  role: string = '';
  dm: string = '';
  usr: string = '';
  // Proprietà per ricerca e ordinamento
  searchText: string = '';
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  // Opzioni per le dropdown - PERSONALIZZA QUESTI VALORI
  clinicaOptions: string[] = [
  ];

  medicoOptions: string[] = [
  ];

  allMedicoOptions: any[] = [
  ];

  turnoOptions: string[] = [
    'MEZZA',
    'INTERA',
  ];

  specialitaOptions: string[] = [
    'CHIRURGO',
    'GENERALISTA',
    'GENERALISTA 360',
    'GENERALISTA PROTESISTA',
    'IGIENISTA',
    'ORTODONTISTA'
  ];

  isAdmin: boolean = false;
  dateFrom: string = '';
  dateTo: string = '';
  // Esponi Math per l'uso nel template
  Math = Math;

  constructor(
    private clinichedatabaseService: ClinichedatabaseService,
    private gceService: GceManagementService,
    private excelService: ExcelService,
    private elementRef: ElementRef,
    private auth: AuthGuardService
  ) {
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const tableContainer = this.elementRef.nativeElement.querySelector('.table-container');
    const toolbar = this.elementRef.nativeElement.querySelector('.toolbar');

    if (tableContainer && !tableContainer.contains(event.target) &&
      toolbar && !toolbar.contains(event.target)) {
      this.deselectRow();
    }
  }

  deselectRow(): void {
    if (this.selectedRow !== null) {
      for (let a = 0; a < this.data.length; a++) {
        this.data[a].edited = false;
      }
      this.selectedRow = null;
    }
  }

  hasPendingChanges(): boolean {
    if (this.dataToDelete.length) {
      return true;
    }
    for (let a = 0; a < this.data.length; a++) {
      if (this.data[a].touched === true) {
        return true;
      }
    }
    return false;
  }

  convertFromNumToString(i) {
    if (i == 4)
      return ('MEZZA');
    if (i == 8)
      return ('INTERA');
    return null;
  }

  convertFromStringToNum(i) {
    if (i == 'MEZZA')
      return (4);
    if (i == 'INTERA')
      return (8);
    return null;
  }

  getDescClinica(code: string) {
    for (let a = 0; a < this.clinicaOptions.length; a++) {
      if (this.clinicaOptions[a].indexOf(code) == 0)
        return (this.clinicaOptions[a])
    }
  }

  getDescDoctor(code: string) {
    for (let a = 0; a < this.allMedicoOptions.length; a++) {
      if (this.allMedicoOptions[a].idfatturazione == code)
        return (this.allMedicoOptions[a].descrizione)
    }
    return (code + ' nt found');
  }

  areNamesEqual(name1: string, name2: string): boolean {
    const normalize = (str: string): string => {
      return str.trim().toLowerCase().replace(/\s+/g, ' ');
    };

    const normalized1 = normalize(name1);
    const normalized2 = normalize(name2);

    if (normalized1 === normalized2) {
      return true;
    }

    const words1 = normalized1.split(' ').sort();
    const words2 = normalized2.split(' ').sort();

    return words1.length === words2.length &&
      words1.every((word, index) => word === words2[index]);
  }

  getIdDoctor(code: string) {
    console.log('this.allMedicoOptions %o for %o', this.allMedicoOptions, code);
    for (let a = 0; a < this.allMedicoOptions.length; a++) {
      if (this.areNamesEqual(this.allMedicoOptions[a].descrizione.toLowerCase().trim(), code.toLowerCase().trim()) == true)
        return (this.allMedicoOptions[a].idfatturazione)
    }
  }

  ngOnInit(): void {
    let usr = this.auth.getUser();
    if (usr != null) {
      this.role = usr['ruolo'];
      this.dm = usr['clinica'];
      if (usr['nomeCompleto'] != null && usr['nomeCompleto'].length > 0) {
        this.usr = usr['nomeCompleto'];
      }
      else {
        if (usr['email'] != null && usr['email'].length > 0) {
          this.usr = usr['email'];
        }
      }
    }
    if (this.role != null && (this.role.toLowerCase() == 'amministratore' || this.role.toLowerCase() == 'amministratore dp')) {
      this.isAdmin = true;
    }
    this.isLoadingCliniche = true;
    this.showb = true;
    this.clinichedatabaseService.getCliniche().subscribe(c => {
      this.clinicaOptions = [];
      for (let a = 0; a < c.length; a++) {
        this.clinicaOptions.push(c[a].descrizione);
      }

      this.gceService.loadMedics().subscribe(m => {
       
        for (let b = 0; b < m.length; b++) {
         // if (m[b].cessato == false) {
            let mdc = { idfatturazione: m[b].idfatturazione, descrizione: m[b].descrizione };
            this.allMedicoOptions.push(mdc);
          //}
        }
        // console.log('medici Options %o', this.allMedicoOptions);
        this.gceService.getAllContracts().subscribe(r => {
         // console.log('R: %o', r);
          this.data = [];
          this.headers = ['clinica', 'medico', 'specialist', 'specialita','data_inizio', 'data_fine', 'num_gg_mese', 'num_mezze_gg_mese', 'tipo_gg_lun', 'tipo_gg_mar', 'tipo_gg_mer', 'tipo_gg_gio', 'tipo_gg_ven', 'tipo_gg_sab', 'tipo_gg_dom', 'note'];
          for (let a = 0; a < r.length; a++) {
            let data_fine = null;
            let data_inizio = null;
            if (!(r[a].data_fine == null)) {
              data_fine = new Date(r[a].data_fine);
              data_fine = this.formatDateLocal(data_fine);
            }
            if (!(r[a].data_inizio == null)) {
              data_inizio = new Date(r[a].data_inizio);
              data_inizio = this.formatDateLocal(data_inizio);
            }
            this.data.push({
              clinica: this.getDescClinica(r[a].cod_clinica),
              cod_clinica_original: r[a].cod_clinica,
              specialist: r[a].specialist,
              specialita: r[a].specialita,
              data_fine: data_fine,
              data_inizio: data_inizio,
              medico: this.getDescDoctor(r[a].idfatturazione),
              idfatturazione_original: r[a].idfatturazione,
              note: r[a].note,
              edited: false,
              touched: false,
              num_gg_mese: r[a].num_gg_mese,
              num_mezze_gg_mese: r[a].num_mezze_gg_mese,
              tipo_gg_dom: this.convertFromNumToString(r[a].tipo_gg_dom),
              tipo_gg_gio: this.convertFromNumToString(r[a].tipo_gg_gio),
              tipo_gg_lun: this.convertFromNumToString(r[a].tipo_gg_lun),
              tipo_gg_mar: this.convertFromNumToString(r[a].tipo_gg_mar),
              tipo_gg_mer: this.convertFromNumToString(r[a].tipo_gg_mer),
              tipo_gg_sab: this.convertFromNumToString(r[a].tipo_gg_sab),
              tipo_gg_ven: this.convertFromNumToString(r[a].tipo_gg_ven)
            });
          }
       //   console.log('DATA: %o', this.data);
          this.isLoadingCliniche = false;
          this.showb = false;
          this.updateDisplayedData();
        });
      });
    });
  }

  loadCliniche(): void {
    this.isLoadingCliniche = true;
    this.clinichedatabaseService.getCliniche().subscribe({

      next: (cliniche) => {
        console.log('cliniche %o', cliniche);
        for (let a = 0; a < cliniche.length; a++) {
          this.clinicaOptions.push(cliniche[a].descrizione);
        }
        this.isLoadingCliniche = false;
      },
      error: (error) => {
        console.error('❌ Errore nel caricamento delle cliniche:', error);
        this.isLoadingCliniche = false;
      }
    });
  }

  stringToDate(dateString: string): Date | null {
    if (!dateString) return null;

    const parts = dateString.split('/');

    if (parts.length !== 3) return null;

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);

    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;

    const date = new Date(year, month, day);

    // Verifica che la data sia valida
    if (date.getDate() !== day || date.getMonth() !== month) {
      return null;
    }

    return date;
  }

  formatDateLocal(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  // ========== METODI PER RICERCA, ORDINAMENTO E PAGINAZIONE ==========

  /**
   * Filtra i dati in base al testo di ricerca
   */
  filterData(): any[] {
    if (!this.searchText || this.searchText.trim() === '') {
      return this.data;
    }

    const searchLower = this.searchText.toLowerCase().trim();
    return this.data.filter(row => {
      const clinica = (row.clinica || '').toLowerCase();
      const medico = (row.medico || '').toLowerCase();
      return clinica.includes(searchLower) || medico.includes(searchLower);
    });
  }

  /**
   * Ordina i dati filtrati
   */
  sortData(filteredData: any[]): any[] {
    if (!this.sortColumn) {
      return filteredData;
    }

    return [...filteredData].sort((a, b) => {
      const valA = (a[this.sortColumn] || '').toString().toLowerCase();
      const valB = (b[this.sortColumn] || '').toString().toLowerCase();

      let comparison = 0;
      if (valA < valB) {
        comparison = -1;
      } else if (valA > valB) {
        comparison = 1;
      }

      return this.sortDirection === 'asc' ? comparison : -comparison;
    });
  }

  /**
   * Applica la paginazione ai dati ordinati
   */
  paginateData(sortedData: any[]): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    return sortedData.slice(startIndex, endIndex);
  }

  /**
   * Aggiorna i dati visualizzati applicando filtro, ordinamento e paginazione
   */
  updateDisplayedData(): void {
    let processedData = this.filterData();
    processedData = this.sortData(processedData);

    // Calcola il numero totale di pagine
    this.totalPages = Math.ceil(processedData.length / this.pageSize);

    // Assicurati che currentPage sia valida
    if (this.currentPage > this.totalPages && this.totalPages > 0) {
      this.currentPage = this.totalPages;
    }
    if (this.currentPage < 1) {
      this.currentPage = 1;
    }

    this.displayedData = this.paginateData(processedData);
  }

  /**
   * Gestisce il cambio del testo di ricerca
   */
  onSearchChange(): void {
    this.currentPage = 1; // Torna alla prima pagina quando si effettua una ricerca
    this.updateDisplayedData();
  }

  /**
   * Gestisce il click su una colonna per l'ordinamento
   */
  onSortClick(column: string): void {
    if (this.sortColumn === column) {
      // Inverte la direzione se si clicca sulla stessa colonna
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // Nuova colonna, ordina in modo ascendente
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }
    this.updateDisplayedData();
  }

  /**
   * Ritorna l'icona di ordinamento per la colonna
   */
  getSortIcon(column: string): string {
    if (this.sortColumn !== column) {
      return '↕️';
    }
    return this.sortDirection === 'asc' ? '↑' : '↓';
  }

  /**
   * Controlla se una colonna è ordinabile
   */
  isSortableColumn(header: string): boolean {
    return this.isClinicaColumn(header) || this.isMedicoColumn(header);
  }

  /**
   * Naviga alla pagina successiva
   */
  nextPage(): void {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateDisplayedData();
    }
  }

  /**
   * Naviga alla pagina precedente
   */
  previousPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateDisplayedData();
    }
  }

  /**
   * Vai a una pagina specifica
   */
  goToPage(page: number): void {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updateDisplayedData();
    }
  }

  /**
   * Cambia il numero di righe per pagina
   */
  changePageSize(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1;
    this.updateDisplayedData();
  }

  /**
   * Restituisce l'array di numeri di pagina da visualizzare
   */
  getPageNumbers(): number[] {
    const pages: number[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      const halfMax = Math.floor(maxPagesToShow / 2);
      let startPage = Math.max(1, this.currentPage - halfMax);
      let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

      if (endPage - startPage < maxPagesToShow - 1) {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
    }

    return pages;
  }

  /**
   * Calcola l'indice di inizio per la paginazione
   */
  getStartIndex(): number {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  /**
   * Calcola l'indice di fine per la paginazione
   */
  getEndIndex(): number {
    const filteredLength = this.filterData().length;
    return Math.min(this.currentPage * this.pageSize, filteredLength);
  }

  /**
   * Ottiene il totale di risultati filtrati
   */
  getFilteredTotal(): number {
    return this.filterData().length;
  }

  // ========== FINE METODI PER RICERCA, ORDINAMENTO E PAGINAZIONE ==========

  onFileSelect(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    this.fileName = file.name.replace(/\.[^/.]+$/, '');
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const targetSheet = workbook.SheetNames.includes(this.sheetName)
        ? this.sheetName
        : workbook.SheetNames[0];

      const firstSheet = workbook.Sheets[targetSheet];

      // Leggi i dati con headers dalla prima riga
      const rawData = XLSX.utils.sheet_to_json(firstSheet, {
        header: 1,
        defval: '',
        blankrows: false
      }) as any[];

      if (rawData.length > 0) {
        const headerRow = rawData[0] as string[];
        this.headers = headerRow.filter(h => h && h.trim() !== '');

        const dataRows = rawData.slice(1);

        this.data = [];
        for (let a = 0; a < dataRows.length; a++) {
          let row = dataRows[a];
          const obj: any = {};
          let data_fine = null;
          let data_inizio = null;

          for (let i = 0; i < this.headers.length; i++) {
            const cellValue = row[i];

            if (this.headers[i].toLowerCase() == 'data_fine' || this.headers[i].toLowerCase() == 'fine val.') {
              if (cellValue instanceof Date) {
                data_fine = this.formatDateLocal(cellValue);
              } else if (typeof cellValue === 'string' && cellValue.trim() !== '') {
                const parsed = this.stringToDate(cellValue);
                if (parsed) {
                  data_fine = this.formatDateLocal(parsed);
                } else {
                  data_fine = cellValue;
                }
              } else if (typeof cellValue === 'number') {
                const excelDate = XLSX.SSF.parse_date_code(cellValue);
                const jsDate = new Date(excelDate.y, excelDate.m - 1, excelDate.d);
                data_fine = this.formatDateLocal(jsDate);
              } else {
                data_fine = cellValue || '';
              }
              obj['data_fine'] = data_fine;
            } else if (this.headers[i].toLowerCase() == 'data_inizio' || this.headers[i].toLowerCase() == 'inizio val.') {
              if (cellValue instanceof Date) {
                data_inizio = this.formatDateLocal(cellValue);
              } else if (typeof cellValue === 'string' && cellValue.trim() !== '') {
                const parsed = this.stringToDate(cellValue);
                if (parsed) {
                  data_inizio = this.formatDateLocal(parsed);
                } else {
                  data_inizio = cellValue;
                }
              } else if (typeof cellValue === 'number') {
                const excelDate = XLSX.SSF.parse_date_code(cellValue);
                const jsDate = new Date(excelDate.y, excelDate.m - 1, excelDate.d);
                data_inizio = this.formatDateLocal(jsDate);
              } else {
                data_inizio = cellValue || '';
              }
              obj['data_inizio'] = data_inizio;
            } else {
              obj[this.headers[i]] = cellValue !== undefined && cellValue !== null ? cellValue : '';
            }
          }

          obj['edited'] = false;
          obj['touched'] = true;
          this.data.push(obj);
        }

        console.log('Parsed data:', this.data);
        this.onFileLoaded(file);
        this.updateDisplayedData(); // Aggiorna i dati visualizzati
      }
    };

    reader.readAsArrayBuffer(file);
  }

  exportToExcel(): void {
    if (this.data.length === 0) {
      alert('⚠️ Nessun dato da esportare');
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(this.data, {
      header: this.headers
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, this.sheetName);

    const fileName = `${this.fileName}_edited.xlsx`;
    XLSX.writeFile(workbook, fileName);

    this.onFileExported();
  }


  ExpMese() {
    this.showb = true;
    const from = this.dateFrom ? this.dateFrom.replace(/-/g, '') : null;
    const to   = this.dateTo   ? this.dateTo.replace(/-/g, '')   : null;

    const call$ = (from && to)
      ? this.gceService.getFilteredReport(from, to)
      : this.gceService.getActualReport();

    call$.subscribe(r => {
      this.showb = false;
      this.excelService.exportGeneric(r, "report_orario");
    });
  }


  // Metodo per salvare le modifiche nel database
  // NOTA: Verifica che GceManagementService abbia i metodi:
  // - addOrEditContracts(contracts: any[])
  // - deleteContracts(contracts: any[])
  /*
  updateDB() {
    let rowsT = [];
    for (let a = 0; a < this.data.length; a++) {
      if (this.data[a].touched == true) {
        if (!(this.data[a].clinica == null) && this.data[a].clinica.length > 3) {
          if (!(this.data[a].medico == null) && this.data[a].medico.length > 3) {
            rowsT.push({
              cod_clinica: this.data[a].clinica.slice(0, 3),
              data_fine: this.data[a].data_fine,
              data_inizio: this.data[a].data_inizio,
              idfatturazione: this.getIdDoctor(this.data[a].medico),
              note: this.data[a].note,
              num_gg_mese: this.data[a].num_gg_mese,
              num_mezze_gg_mese: this.data[a].num_mezze_gg_mese,
              tipo_gg_dom: this.convertFromStringToNum(this.data[a].tipo_gg_dom),
              tipo_gg_gio: this.convertFromStringToNum(this.data[a].tipo_gg_gio),
              tipo_gg_lun: this.convertFromStringToNum(this.data[a].tipo_gg_lun),
              tipo_gg_mar: this.convertFromStringToNum(this.data[a].tipo_gg_mar),
              tipo_gg_mer: this.convertFromStringToNum(this.data[a].tipo_gg_mer),
              tipo_gg_sab: this.convertFromStringToNum(this.data[a].tipo_gg_sab),
              tipo_gg_ven: this.convertFromStringToNum(this.data[a].tipo_gg_ven)
            });
          }
        }
      }
    }
    console.log('ROWS TO SAVE: %o', rowsT);
    this.gceService.addOrEditContracts(rowsT).subscribe(r => {
      console.log('salvato ok');
      let rowsDel = [];
      for (let a = 0; a < this.dataToDelete.length; a++) {
        if (!(this.dataToDelete[a].clinica == null) && this.dataToDelete[a].clinica.length > 3) {
          if (!(this.dataToDelete[a].medico == null) && this.dataToDelete[a].medico.length > 3) {
            rowsDel.push({
              cod_clinica: this.dataToDelete[a].clinica.slice(0, 3),
              idfatturazione: this.getIdDoctor(this.dataToDelete[a].medico)
            });
          }
        }
      }
      console.log('ROWS TO DELETE %o', rowsDel);
      this.gceService.deleteContracts(rowsDel).subscribe(r => {
        console.log('delete ok %o', r);
        this.dataToDelete = [];
        this.ngOnInit();
      });
    });
  }
    */

  async updateDB() {
    if (!window.confirm('Sei sicuro di voler aggiornare il DB con le modifiche fatte?')) {
      return;
    }

    this.showb = true;

    // Prepara i dati da salvare (righe toccate/editate)
    const itemsToSave = this.data
      .filter(item => item.touched === true)
      .map(item => ({
        cod_clinica: item.clinica.substr(0, 3),
        cod_clinica_original: item.cod_clinica_original,
        specialist: item.specialist,
        specialita: item.specialita,
        data_fine: item.data_fine,
        data_inizio: item.data_inizio,
        idfatturazione: item.idfatturazione_medico_selected != null &&item.idfatturazione_medico_selected>0 ? item.idfatturazione_medico_selected : this.getIdDoctor(item.medico),
        idfatturazione_original: item.idfatturazione_original,
        note: item.note,
        num_gg_mese: item.num_gg_mese,
        num_mezze_gg_mese: item.num_mezze_gg_mese,
        tipo_gg_dom: this.convertFromStringToNum(item.tipo_gg_dom),
        tipo_gg_gio: this.convertFromStringToNum(item.tipo_gg_gio),
        tipo_gg_lun: this.convertFromStringToNum(item.tipo_gg_lun),
        tipo_gg_mar: this.convertFromStringToNum(item.tipo_gg_mar),
        tipo_gg_mer: this.convertFromStringToNum(item.tipo_gg_mer),
        tipo_gg_sab: this.convertFromStringToNum(item.tipo_gg_sab),
        tipo_gg_ven: this.convertFromStringToNum(item.tipo_gg_ven)
      }));

    // Raccoglie TUTTI i record da cancellare prima dell'inserimento:
    // 1) Record toccati che esistevano nel DB (hanno le chiavi originali)
    const allItemsToDelete: { cod_clinica: string, idfatturazione: string }[] = [];

    for (const item of itemsToSave) {
      if (item.cod_clinica_original != null && item.idfatturazione_original != null) {
        allItemsToDelete.push({
          cod_clinica: item.cod_clinica_original,
          idfatturazione: item.idfatturazione_original
        });
      }
    }

    // 2) Righe eliminate manualmente dall'utente
    for (const item of this.dataToDelete) {
      if (item.clinica && item.clinica.length > 3 && item.medico && item.medico.length > 3) {
        allItemsToDelete.push({
          cod_clinica: item.clinica.slice(0, 3),
          idfatturazione: this.getIdDoctor(item.medico)
        });
      }
    }

    console.log('ROWS TO DELETE:', allItemsToDelete);
    console.log('ROWS TO SAVE:', itemsToSave);

    // Helper per attendere
    const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    // FASE 1: Cancella tutti i record esistenti (toccati + eliminati)
    for (let i = 0; i < allItemsToDelete.length; i++) {
      const item = allItemsToDelete[i];
      try {
        console.log(`Cancellazione ${i + 1}/${allItemsToDelete.length}:`, item);
        await this.gceService.deleteContract(item).pipe(take(1)).toPromise();
        console.log(`Cancellato ${i + 1}/${allItemsToDelete.length}`);
      } catch (err) {
        console.error(`Errore cancellazione ${i + 1}:`, err);
      }
      if (i < allItemsToDelete.length - 1) {
        await wait(1000);
      }
    }

    // FASE 2: Inserisce i record aggiornati
    for (let i = 0; i < itemsToSave.length; i++) {
      const item = itemsToSave[i];
      try {
        console.log(`Inserimento ${i + 1}/${itemsToSave.length}:`, item);
        await this.gceService.postContract(item).pipe(take(1)).toPromise();
        console.log(`Inserito ${i + 1}/${itemsToSave.length}`);
      } catch (err) {
        console.error(`Errore inserimento ${i + 1}:`, err);
      }
      if (i < itemsToSave.length - 1) {
        await wait(1300);
      }
    }

    console.log('Tutte le operazioni completate');
    this.dataToDelete = [];
    this.showb = false;
    this.ngOnInit();
  }


  addRow(): void {
    const newRow: any = {};
    this.headers.forEach(header => {
      newRow[header] = '';
    });

    newRow['edited'] = true;
    newRow['touched'] = true;
    // Inserisce la nuova riga all'inizio dell'array
    this.data.unshift(newRow);

    // La nuova riga è ora alla posizione 0
    this.selectedRow = 0;

    this.onRowAdded(0);
    this.updateDisplayedData(); // Aggiorna i dati visualizzati

    // Naviga alla prima pagina dove si trova la nuova riga
    this.goToPage(1);
  }

  getHeaderLabel(header: string): string {
    const labelMap: { [key: string]: string } = {
      'clinica': 'Clinica',
      'specialist': 'Specialist',
      'specialita': 'Specialità',
      'medico': 'Medico',
      'data_inizio': 'Data Inizio',
      'data_fine': 'Data Fine',
      'num_gg_mese': 'Giorni/Mese',
      'num_mezze_gg_mese': 'Mezze Giornate/Mese',
      'tipo_gg_lun': 'Lun',
      'tipo_gg_mar': 'Mar',
      'tipo_gg_mer': 'Mer',
      'tipo_gg_gio': 'Gio',
      'tipo_gg_ven': 'Ven',
      'tipo_gg_sab': 'Sab',
      'tipo_gg_dom': 'Dom',
      'note': 'Note'
    };

    return labelMap[header] || header;
  }

  getMedicoOptionsForRow(rowIndex: number): string[] {
    return this.medicoOptions;
  }

  onMedicoChange(rowIndex: number, nomeMedico: string): void {
    const row = this.data[rowIndex];
    const normalizedNome = nomeMedico ? nomeMedico.trim().toUpperCase() : '';
    const option = (this.medicoOptions as any[]).find((o: any) => {
      const candidato = (o.nome || o.descrizione || o.name || '').trim().toUpperCase();
      return candidato === normalizedNome;
    });
    if (option) {
      row['idfatturazione_medico_selected'] = option.idfatturazione != null ? option.idfatturazione : null;
    } else {
      row['idfatturazione_medico_selected'] = null;
    }
    const colIndex = this.headers.findIndex(h => this.isMedicoColumn(h));
    this.onCellChange(rowIndex, colIndex, nomeMedico);
  }

  onClinicaChange(rowIndex: number, clinica: string): void {
    //console.log('onClinicaChange: %o', clinica);
    const row = this.data[rowIndex];

    // Reset del medico quando cambia la clinica
    const medicoCol = this.headers.find(h => this.isMedicoColumn(h));
    if (medicoCol) {
      row[medicoCol] = '';
    }

    // Se non c'è clinica selezionata, svuota le opzioni
    if (!clinica || clinica.trim() === '') {
      row['medicoOptions'] = [];
      return;
    }

    // Carica i medici per la clinica selezionata
    this.loadMediciByClinica(rowIndex, clinica);

    // Notifica il cambio
    const colIndex = this.headers.findIndex(h => this.isClinicaColumn(h));
    this.onCellChange(rowIndex, colIndex, clinica);
  }

  // Chiamata HTTP per caricare i medici
  loadMediciByClinica(rowIndex: number, clinica: string): void {
    const row = this.data[rowIndex];
    const previousMedico = row['medico'];
    row['loadingMedici'] = true;
    // Non svuotare medicoOptions subito: Angular azzererebbe il [(ngModel)] della select
    // perché il valore corrente non si troverebbe nelle opzioni vuote.
    // L'array viene sostituito solo quando arrivano i nuovi dati.

    this.clinichedatabaseService.getMedicsClinica(clinica.slice(0, 3)).subscribe({
      next: (medici) => {
        this.medicoOptions = [];
        for (let a = 0; a < medici.length; a++) {
          this.medicoOptions.push(medici[a]);
        }
        this.medicoOptions.sort();
        // Ripristina il valore del medico se Angular lo ha azzerato durante il caricamento
        if (previousMedico && !row['medico']) {
          row['medico'] = previousMedico;
        }
        row['loadingMedici'] = false;
      },
      error: (error) => {
        console.error('❌ Errore nel caricamento dei medici:', error);
        row['loadingMedici'] = false;
        alert(`Errore nel caricamento dei medici per ${clinica}.`);
      }
    });
  }

  deleteSelectedRow(): void {
    if (this.selectedRow !== null && this.selectedRow < this.data.length) {
      this.dataToDelete.push(this.data[this.selectedRow]);
      const deletedRowIndex = this.selectedRow;
      const deletedRowData = { ...this.data[this.selectedRow] };

      this.data.splice(this.selectedRow, 1);

      this.onRowDeleted(deletedRowIndex, deletedRowData);
      this.selectedRow = null;
      this.updateDisplayedData(); // Aggiorna i dati visualizzati
    }
  }

  onRowClick(rowIndex: number): void {
    // Trova l'indice della riga nei dati originali
    const actualRow = this.displayedData[rowIndex];
    const actualIndex = this.data.indexOf(actualRow);

    this.selectedRow = actualIndex;
    this.onRowSelected(actualIndex);
  }

  onCellFocus(row: number, col: number): void {
    this.selectedCell = { row, col };
    this.onCellFocused(row, col);
  }

  onCellBlur(row: number, col: number): void {
    this.onCellBlurred(row, col);
    this.selectedCell = null;
  }

  onCellChange(row: number, col: number, value: any): void {
    const columnName = this.headers[col];
    this.onCellValueChanged(row, col, value, columnName);
  }


  isClinicaColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower === 'clinica';
  }

  isDateIColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower == 'data_inizio' || lower == 'inizio val.';
  }

  isDateFColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower == 'data_fine' || lower == 'fine val.';
  }

  isQuantityColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();

    if (lower == 'num_mezze_gg_mese')
      return true;
    if (lower == 'num_gg_mese')
      return true;
    if (lower == 'num mezze gg mese')
      return true;
    if (lower == 'nun mezze gg mese')
      return true;
    if (lower == 'nun gg mese')
      return true;
    return false;
  }

  isMedicoColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower === 'medico';
  }

  isSpecialistColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower === 'specialist';
  }

  isSpecialitaColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return (lower === 'specialita'||lower === 'specialità');
  }

  isDayColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    //console.log('checkIsDay %o',lower);
    if (lower == 'lun.')
      return true;
    if (lower == 'mar.')
      return true;
    if (lower == 'merc.')
      return true;
    if (lower == 'mer.')
      return true;
    if (lower == 'gio.')
      return true;
    if (lower == 'ven.')
      return true;
    if (lower == 'sab.')
      return true;
    if (lower == 'dom.')
      return true;
    if (lower == 'tipo_gg_dom')
      return (true);
    if (header == 'tipo_gg_lun')
      return (true);
    if (header == 'tipo_gg_mar')
      return (true);
    if (header == 'tipo_gg_mer')
      return (true);
    if (header == 'tipo_gg_gio')
      return (true);
    if (header == 'tipo_gg_ven')
      return (true);
    if (header == 'tipo_gg_sab')
      return (true);
    return false;

  }

  isNoteColumn(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower.includes('note');
  }

  isEdited(header: string): boolean {
    const lower = header.toLowerCase().trim();
    return lower.includes('edited');
  }

  isReadOnlyColumn(header: string): boolean {
    return !this.isClinicaColumn(header) &&
      !this.isMedicoColumn(header) &&
      !this.isDayColumn(header) &&
      !this.isNoteColumn(header) &&
      !this.isQuantityColumn(header) &&
      !this.isDateIColumn(header) &&
      !this.isDateFColumn(header) &&
      !this.isSpecialistColumn(header)&&
      !this.isSpecialitaColumn(header)
  }

  isWeekendColumn(header: string): boolean {
    const lower = header.toLowerCase();
    return lower.includes('sabato') || lower.includes('domenica') ||
      lower.includes('sab') || lower.includes('dom');
  }

  getHeaderIcon(header: string): string {
    if (this.isSortableColumn(header)) {
      return this.getSortIcon(header);
    }
    if (this.isClinicaColumn(header) || this.isMedicoColumn(header) ||
      this.isSpecialitaColumn(header) || this.isDayColumn(header)) {
      return '▼';
    }
    if (this.isNoteColumn(header)) {
      return '✏️';
    }
    return '✏️';
  }

  // ========== EVENTI PERSONALIZZABILI ==========

  onFileLoaded(file: File): void {
    console.log('📁 File caricato:', file.name);
    console.log('📊 Dati caricati: %o', this.data);
    console.log('📋 Colonne:', this.headers);
    console.log('🏥 Cliniche disponibili:', this.clinicaOptions);
    console.log('👨‍⚕️ Medici disponibili:', this.medicoOptions);
    console.log('🩺 Specialità disponibili:', this.specialitaOptions);
    console.log('⏰ Turni disponibili:', this.turnoOptions);
  }

  onFileExported(): void {
    console.log('💾 File esportato con successo');
    alert('✅ File Excel esportato con successo!');
  }

  onCellValueChanged(row: number, col: number, value: any, columnName: string): void {
    //console.log(`✏️ Cella modificata - Riga: ${row + 1}, Colonna: ${columnName}, Valore: ${value}`);
  }

  onCellFocused(row: number, col: number): void {
    const columnName = this.headers[col];
    //console.log(`🎯 Cella selezionata - Riga: ${row + 1}, Colonna: ${columnName}`);
  }

  onCellBlurred(row: number, col: number): void {
    // console.log(`👋 Cella deselezionata`);
  }

  onRowAdded(rowIndex: number): void {
    console.log('➕ Nuova riga aggiunta alla posizione:', rowIndex + 1);
  }

  onRowDeleted(rowIndex: number, deletedData: any): void {
    console.log('🗑️ Riga eliminata:', rowIndex + 1);
    console.log('Dati eliminati:', deletedData);
  }

  onRowSelected(rowIndex: number): void {
    for (let a = 0; a < this.data.length; a++) {
      this.data[a].edited = false;
    }
    //console.log('👆 Riga selezionata: %o clinica: %o', rowIndex + 1, this.data[rowIndex].clinica);
    if (!(this.data[rowIndex].clinica == null) && this.data[rowIndex].clinica.length > 0)
      this.loadMediciByClinica(rowIndex, this.data[rowIndex].clinica);
    // Pre-inizializza con il valore originale: se l'utente non tocca la dropdown
    // del medico, questo valore viene usato nel POST al posto di getIdDoctor()
    this.data[rowIndex]['idfatturazione_medico_selected'] = this.data[rowIndex].idfatturazione_original;
    this.data[rowIndex].edited = true;
    this.data[rowIndex].touched = true;
    console.log('Dati riga:', this.data[rowIndex]);
  }

}
